import { createCachedSelector, path, prop } from '@cbridge-utils/redux';
import { createDefaultCachedSelectorOptions } from '@cbridge-utils/reselect';
import { IServer } from '../server.interface';
import { serverStoreSelector } from '../server.selector';

export const serverSelector = createCachedSelector(
  [
    path(serverStoreSelector).data(),
    prop<{ serverId: IServer['serverId'] }>().serverId(),
  ],
  (server, serverId) => {
    return server[serverId];
  },
)({
  ...createDefaultCachedSelectorOptions(),
  keySelector: prop<{ serverId: IServer['serverId'] }>().serverId(),
});
